module.exports = __webpack_public_path__ + "static/media/baby-preto.c8047d4c.webp";